module.exports = __webpack_public_path__ + "img/creator-shield-favicon-new.f64807bc.png";